module.exports = __webpack_public_path__ + "static/grey1-d570a298c1bbb6047052badc50857c11.png";